import { useEffect } from 'react';
import { zoomProjection } from '../utils/functions/playcanvas/zoomProjection';

export function useProjectionZoom(isOrthographic: boolean) {
    useEffect(() => {
        if (!isOrthographic) return;

        const handleWheel = (event: WheelEvent) => {
            const target = event.target as Element;
            if (target.closest('.toolbar') || target.closest('button')) {
                return;
            }

            event.preventDefault();
            const delta = event.deltaY * -0.01;
            zoomProjection(delta);
        };

        document.addEventListener('wheel', handleWheel, { passive: false });
        return () => document.removeEventListener('wheel', handleWheel);
    }, [isOrthographic]);
} 